export const formatOtterSgMedicine = medicine => {
  return {
    amountPerTime: +medicine.amountPerTime,
    description: medicine.description.name,
    vendor: medicine.description.vendor,
    unitPrice: +medicine.description.unitPrice,
    unitPriceBeforeTax: +medicine.description.unitPriceBeforeTax,
    quantity: +medicine.quantity,
    duration: +medicine.duration,
    note: medicine.note,
    uom: medicine.uomUnit,
    uomCode: medicine.uomCode,
    isTakenFromStore: true,
    useCustomInstruction: medicine.useCustomInstruction,
    ottersgProductId: medicine.ottersgProductId,
    frequencyCode: medicine.frequencyCode,
    doseUnitCode: medicine.doseUnitCode,
    routeCode: medicine.routeCode,
    durationUnitCode: medicine.durationUnitCode,
    doseUnit: medicine.doseUnit,
    frequency: medicine.frequency,
    route: medicine.route,
    durationUnit: medicine.durationUnit,
  };
};

export const formatLifepackMedicine = medicine => {
  return {
    amountPerTime: +medicine.amountPerTime,
    description: medicine.description.name,
    vendor: medicine.description.vendor,
    unitPrice: +medicine.description.unitPrice,
    unitPriceBeforeTax: +medicine.description.unitPriceBeforeTax,
    quantity: +medicine.quantity,
    duration: +medicine.duration,
    note: medicine.note,
    uom: medicine.uomUnit,
    uomCode: medicine.uomCode,
    isTakenFromStore: true,
    useCustomInstruction: false,
    lifepackProductId: medicine.lifepackProductId,
    frequencyCode: medicine.frequencyCode,
    doseUnitCode: medicine.doseUnitCode,
    routeCode: medicine.routeCode,
    durationUnitCode: medicine.durationUnitCode,
    doseUnit: medicine.doseUnit,
    frequency: medicine.frequency,
    route: medicine.route,
    durationUnit: medicine.durationUnit,
  };
};

export const formatGlocoMedicine = medicine => {
  return {
    amountPerTime: +medicine.amountPerTime,
    description: medicine.description.name,
    vendor: medicine.description.vendor,
    unitPrice: +medicine.description.unitPrice,
    quantity: +medicine.quantity,
    note: medicine.note,
    uom: medicine.uomUnit,
    isTakenFromStore: true,
    useCustomInstruction: medicine.useCustomInstruction,
    doseUnit: medicine.doseUnit,
    frequency: medicine.frequency,
  };
};
